module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon-th-39ab279d71bddbf04f2a24dde571182e.png";